import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from 'AuthContext';
import { JsxElement } from 'typescript';
import { PlatformContext } from 'PlatformContext';
import { useMutation } from '@apollo/client';
import { AuthenticateDataData, AuthenticateVars, GET_AUTHENTICATE } from 'graphql/AuthQueries';
import { setAllRequests } from '_reducers/puzzleRequests';
import { useAppDispatch } from '_store';
import { EledoPageLoader } from 'components/library';

type LocationState = {
  userId: string
  email: string
  from: {
    pathname: string
    search: string
  }
}

const PrivateRoute = ({ children }: JsxElement) => {
  const platform = useContext(PlatformContext)

  const auth = useContext(AuthContext)

  const location = useLocation()
  
  const navigate = useNavigate()
  const dispatch = useAppDispatch();

  const state = useLocation().state as LocationState;

  const [appLoading, setAppLoading] = useState(true);
  
  const [doAuth] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
    onCompleted: (data, clientOptions) => {
      // console.log(data)
              
      if(data){
        if((data.authenticate.accounts?.length || 0) > 0){
          setAppLoading(false);
          return navigate("/login/accountSelect", { state: { ...clientOptions?.variables, accounts: data.authenticate.accounts }})
        }
        const authVars = clientOptions?.variables as AuthenticateVars
        
        auth.login(data.authenticate, authVars.type);
        
        if(data.authenticate.requests){
          dispatch(setAllRequests(data.authenticate.requests));
        }
// console.log(state.from)
        if(data.authenticate.account != null){
          setAppLoading(false);
          if(state?.from?.pathname){
            navigate(state.from.pathname + state.from.search);
          }else{
            navigate("/templates/mine");
          }
        }
      }
    },
    onError: (error) => {
      console.log(error);
      setAppLoading(false);
    }});

    useEffect(() => {
      if(platform === undefined || platform.initSuccess !== true || platform.authService === undefined){
        setAppLoading(false)
        return
      }

      if(platform.accountAutoCreate){
        platform.authService.provideAuthUserCreate()
          .then(authCreate => {
            platform.authService.provideAuthData()
            .then(authData => {
              if(authData){
                  doAuth({ variables: { type: authData.type, payload: authData.token, create: authCreate }})
              } else {
                setAppLoading(false);
              }
            });
          })
      } else {
        platform.authService.provideAuthData()
        .then(authData => {
          // console.log("provided", authData)
          if(authData){
              doAuth({ variables: { type: authData.type, payload: authData.token }})
          } else {
            setAppLoading(false);
          }
        });
      }
    }, [platform, doAuth])

    if(appLoading) {
      return <EledoPageLoader text="Logging in..."/>;
    }

    if (auth.account) {
      return children
    }

    if (!auth.canLetLogin) {
      return <Navigate to="/start" state={{ from: location }} replace />
    }

    return <Navigate to="/login/start" state={{ from: location }} replace />
}

export default PrivateRoute;